// config
// dependencies
import { Map } from "immutable";
import { createSelector } from "reselect";

import Config from "./Config";

// selectors
import { getJobs } from "../../../selectors/jobs";
import { getURLParam } from "../../../selectors/navigation";

export const getJobID = (state) => getURLParam(state, "jobID");
export const getUI = (state) => state.page.get(Config.pageName, Map());

export const getActiveSingleJob = createSelector([getJobs, getJobID], (jobs, jobID) =>
	jobs.find((job) => job.get("_id") === jobID, null, null)
);

export const getNonActiveSingleJob = (state) => getUI(state).getIn(["job"], null);

/**
 * Returns a job. If the job exists as an active job, it will return
 * that object. If not, it will return it from the page store.
 */
export const getSingleJob = (state) => {
	const activeJob = getActiveSingleJob(state);

	if (!activeJob) {
		return getNonActiveSingleJob(state);
	}

	return activeJob;
};
